import { IParametre, IParametreTumu } from "./IParametre/IParametre";

/** Kayıt hareket türü */
export type IKayitHareketTuru = "Eklendi" | "Değiştirildi" | "Silindi" | "Geri Alındı";

export interface IKayitHareket {
    sahip?: string;
    turu?: IKayitHareketTuru;
    tarih?: Date;
}

/** Kart türleri */
export enum IKartTuru {
    YOK = 'YOK',
    KART = 'KART',
    SABLON = 'SABLON',
    BILDIRIM = 'BILDIRIM',
    FIRKOD = 'FIRKOD',
    REKLAM = 'REKLAM',
    REST = 'REST',
    VERI = 'VERI',
    BULUT3D = 'BULUT3D',
    UYGULAMA = 'UYGULAMA',
    ARAMA = 'ARAMA',
    VERITABANI = 'VERITABANI',
    UYAR_DOKUM = 'UYAR_DOKUM',
    SISTEM = "SISTEM",
}

/** Gizlilik seçenekleri */
export type TurGizlilik =
    | "Admin"
    | "Herkese Açık"
    | "Hiçkimse"
    | "Takipleştiklerinizle"
    | "Takip Edenlerle"
    | "Takip Ettiklerinizle"
    | "Listedekilerle"
    | "Listedekiler Hariç"
    | "Seçilen Gruplarla"
    | "Seçilen Gruplar Hariç"
    | "Sadece Ben"
    | "Sistem"
    | "Uygulama";

export const TurGizlilikBilgi: Record<TurGizlilik, { simge?: string; simgeSinif?: string; aciklama?: string }> = {
    "Admin": { simge: "🛠️", simgeSinif: "user shield", aciklama: "Yalnızca yöneticiler görebilir" },
    "Herkese Açık": { simge: "🌍", simgeSinif: "globe europe", aciklama: "Paylaşımınız Tüm Sistemde Herkes Tarafından Görünür" },
    "Hiçkimse": { simge: "🚫", simgeSinif: "eye slash", aciklama: "Kimse Göremez" },
    "Takipleştiklerinizle": { simge: "👥", simgeSinif: "people arrows", aciklama: "Sizi Takip Edenler ve Ettikleriniz Görebilir" },
    "Takip Edenlerle": { simge: "🚶🏽‍♂️", simgeSinif: "people arrows", aciklama: "Sizi Takip Edenlere Görünür" },
    "Takip Ettiklerinizle": { simge: "👀", simgeSinif: "people arrows", aciklama: "Takip Ettiklerinize Görünür" },
    "Listedekilerle": { simge: "📝", simgeSinif: "clipboard list", aciklama: "Sadece Listede Seçtiklerinize Görünür" },
    "Listedekiler Hariç": { simge: "📜", simgeSinif: "headphones", aciklama: "Listede Seçtikleriniz Hariç Herkese Görünür" },
    "Seçilen Gruplarla": { simge: "👨‍👨‍👦‍👦", simgeSinif: "users", aciklama: "Seçtiğiniz Grup Üyelerine Görünür" },
    "Seçilen Gruplar Hariç": { simge: "👨‍👦‍👦", simgeSinif: "assistive listening systems", aciklama: "Seçtiğiniz Gruplar Hariç Herkese Görünür" },
    "Sadece Ben": { simge: "🔒", simgeSinif: "eye slash", aciklama: "Sadece Siz Görebilirsiniz" },
    "Sistem": { simge: "💾", simgeSinif: "centos", aciklama: "Sistem İçin Görünür" },
    "Uygulama": { simge: "📱", simgeSinif: "mobile alternate", aciklama: "Sadece Uygulama Kapsamında Görünür" },
};



/** Etiket Modeli */
export interface IEtiket {
    renkYazi?: string;
    renkArka?: string;
    simge?: string;
    degeri?: string;
    saltOkunur?: boolean;
}

/** Yüz Etiketleme */
export interface IYuzEtiketi {
    id: string;
    x: number;           // % sol kenardan (0-100)
    y: number;           // % üst kenardan (0-100)
    w: number;           // % genişlik (0-100)
    h: number;           // % yükseklik (0-100)
    kisiId?: string;     // sistem kullanıcısı ise _id
    soyagaciKisiId?: string; // soyağacı kişisi ise soyAgaciKisiler._id
    kisiIsmi: string;    // her zaman dolu
    resimUrl?: string;   // soyağacı kişisinin profil resmi URL'i
}

/** Ek Dosya Türleri */
export enum IEkTuru {
    YOK = 'YOK',
    ACIKLAMA = 'ACIKLAMA',
    RESIM = 'RESIM',
    VIDEO = 'VIDEO',
    SES = 'SES',
    YOUTUBE = 'YOUTUBE',
    REFERANS = 'REFERANS',
    REFERANSSAYFA = 'REFERANSSAYFA',
    YAPAYZEKA = 'YAPAYZEKA',
    DOSYA = 'DOSYA',
    FIKOGL = 'FIKOGL',
    FIKOGLS = 'FIKOGLS',
    FIKOOPGL = 'FIKOOPGL',
    FIKOOPGLv1 = 'FIKOOPGLv1',
    FIKOWRL = 'FIKOWRL',
    STL = 'STL',
    DXF = 'DXF',
    KONUM = 'KONUM',
    ANKET = 'ANKET',
    SORU = 'SORU',
    REKLAM = 'REKLAM',
    UYARDOKUM = 'UYARDOKUM',
    EKREFERANS = 'EKREFERANS',
    UYGULAMAICERIK = 'UYGULAMAICERIK',
}

/** Ek Dosya Yapısı */
export interface IEk {
    turu?: IEkTuru;
    _id?: string;
    ismi?: string;
    tipi?: string;
    sahip?: string;
    bilgiler?: any;
    boyut?: number;
    kokDosya?: any;
    kokDosyaObjectUrl?: string;
    rota?: string;
    parametreler?: IParametre[];
    uygulama?: string;
    vt?: IVT | IUyarVT;
    yol?: IYollar | IUyarYollar;
    konum?: any;
    rid?: string; // KartReferansId
    resimid?: string; // KartReferansId
    isleniyor?: { evet: boolean, [key: string]: any };
    transkript?: string;
    transkriptSegmentleri?: { start: number; end: number; text: string }[];
    yuzEtiketleri?: IYuzEtiketi[];
    yuzEtiketGosterim?: 'hover' | 'surekli' | 'liste' | 'kapali';
    bilesen?: string;
    bilesenGorunum?: string;
}

/** İçerik */
export interface IIcerik {
    _id?: string;
    ek?: IEk;
    aciklama?: string;
    html?: string;
    sifre?: string;
}

/** Veri Tabanı Tablo Kodları */
export type IVT =
    | 'FikoYT.sistem.hataliGirisler'
    | 'FikoYT.sistem.basariliGirisler'
    | 'FikoYT.sistem.yapilanCikislar'
    | 'FikoYT.sistem.baglantilar'
    | 'FikoYT.sistem.hareketler'

    | 'FikoYT.sistem.gruplar'

    | 'FikoYT.sistem.takipler'

    | 'FikoYT.sistem.aileBaglari'

    | 'FikoYT.sistem'

    | 'FikoYT.sistem.firmalar'
    | 'FikoYT.sistem.firma.personeller'
    | 'FikoYT.sistem.firma.departmanlar'
    | 'FikoYT.sistem.firma.yetkiler'
    | 'FikoYT.sistem.cihazlar'
    | 'FikoYT.sistem.cihaz.olaylar'
    | 'FikoYT.sistem.cihaz.komutlar'
    | 'FikoYT.sistem.cihaz.tetikleyiciler'
    | 'FikoYT.sistem.cihaz.tipler'
    | 'FikoYT.sistem.denetim'
    | 'FikoYT.sistem.giris_cikis'
    | 'FikoYT.sistem.ajanlar'
    | 'FikoYT.sistem.gorevler'
    | 'FikoYT.sistem.bildirimler'
    | 'FikoYT.sistem.mesajlar'
    | 'FikoYT.sistem.soketler'
    | 'FikoYT.sistem.teklifler'
    | 'FikoYT.sistem.siparisler'
    | 'FikoYT.sistem.kare_kodlar'
    | 'FikoYT.sistem.parametreSetleri'
    | 'FikoYT.sistem.mail.mesajlar'
    | 'FikoYT.sistem.mail.hesaplar'
    | 'FikoYT.sistem.mail.audit'

    ;



/** İfade Türleri */
export enum IIfadeTuru {
    BEGENDI = 'BEGENDI',      // 👍 Beğendi
    BEGENME = 'BEGENME',       // 👎 Beğenmedi
    KALP = 'KALP',             // ❤️ Sevdi
    GULDU = 'GULDU',           // 😂 Güldü
    SASKIN = 'SASKIN',         // 😮 Şaşırdı
    UZGUN = 'UZGUN',           // 😢 Üzgün
    KIZGIN = 'KIZGIN',         // 😡 Kızgın
    DUSUNUYOR = 'DUSUNUYOR',   // 🤔 Düşünüyor
}

export const IfadeBilgi: Record<IIfadeTuru, { simge: string; isim: string; renk: string }> = {
    [IIfadeTuru.BEGENDI]: { simge: '👍', isim: 'Beğendi', renk: '#3b82f6' },
    [IIfadeTuru.BEGENME]: { simge: '👎', isim: 'Beğenmedi', renk: '#64748b' },
    [IIfadeTuru.KALP]: { simge: '❤️', isim: 'Sevdi', renk: '#ef4444' },
    [IIfadeTuru.GULDU]: { simge: '😂', isim: 'Güldü', renk: '#f59e0b' },
    [IIfadeTuru.SASKIN]: { simge: '😮', isim: 'Şaşırdı', renk: '#8b5cf6' },
    [IIfadeTuru.UZGUN]: { simge: '😢', isim: 'Üzgün', renk: '#6366f1' },
    [IIfadeTuru.KIZGIN]: { simge: '😡', isim: 'Kızgın', renk: '#dc2626' },
    [IIfadeTuru.DUSUNUYOR]: { simge: '🤔', isim: 'Düşünüyor', renk: '#10b981' },
};

/** İfade Kaydı */
export interface IIfade {
    sahip: string;           // Kullanıcı ID
    turu: IIfadeTuru;        // İfade türü
    tarih: Date;             // İfade tarihi
}

export type IYollar =
    /** NOT: Takipler */
    | 'FikoYT.sistem.takipler.takipEdildi'
    | 'FikoYT.sistem.takipler.takipciliktenCikildi'
    | 'FikoYT.sistem.takipler.takipBirakildi'

    | 'FikoYT.sistem.gruplar.kalem'

    | 'FikoYT.sistem.yazismalar.kalem'
    | 'FikoYT.sistem.mesajlar.kalem'

    | 'FikoYT.sistem.hareketler.kalem'
    | 'FikoYT.sistem.hareketler.begen'
    | 'FikoYT.sistem.hareketler.ifade'

    | 'FikoYT.sistem.istemci.log'

    | 'FikoYT.sistem.aileBaglari.kalem'
    | 'FikoYT.sistem.aileBaglari.onaylandi'
    | 'FikoYT.sistem.aileBaglari.reddedildi'

    | 'FikoYT.sistem.firmalar.*'
    | 'FikoYT.sistem.cihazlar.*'
    | 'FikoYT.sistem.denetim.*'
    | 'FikoYT.sistem.ajanlar.*'
    | 'FikoYT.sistem.ticaret.*'
    | 'FikoYT.sistem.iletisim.*'
    | 'FikoYT.sistem.parametreSetleri.*'
    ;


export type IUyarVT =
    | 'FikoYT.Uyar.projeler'
    | 'FikoYT.Uyar.firmalar'
    | 'FikoYT.Uyar.firmalar.personeller'
    | 'FikoYT.Uyar.teklifler'
    ;

export type IUyarYollar =
    | 'FikoYT.Uyar.firmalar.kalem'
    | 'FikoYT.Uyar.firmalar.personeller.kalem'
    | 'FikoYT.Uyar.teklifler.kalem'
    ;


/** Kart Yapısı */
export interface IKart<T = any> {
    _id?: string;
    _uid?: string;
    turu?: IKartTuru;
    vt?: IVT;
    yol?: IYollar;

    sahip?: string;

    gizlilik?: TurGizlilik;
    gizlilikListe?: any[];

    etiketler?: IEtiket[];
    kisiler?: string[];

    icerikler?: IIcerik[];

    silindi?: boolean;

    hareketler?: IKayitHareket[];

    uygulama?: string[];

    parametreler?: IParametre[];

    begenenler?: string[];
    begenmeSayisi?: number;

    ifadeler?: IIfade[];        // Tüm ifadeler
    ifadeSayilari?: Record<IIfadeTuru, number>;  // İfade türlerine göre sayılar

    ayarlar?: Record<string, any>;

    tarih?: Date;

    veri?: T;

    konum?: any;

    dosyalar?: IEk[];

    /** Düzenlenme tarihi */
    duzenlenmeTarihi?: Date;

    /** Taslak mı */
    taslakMi?: boolean;

    /** Hangi şablondan oluşturuldu */
    sablonId?: string;

    /** Yorum/alt kart sayısı (cache) */
    yorumSayisi?: number;

    /** YeFikola (repost) sayısı */
    yeFikolaSayisi?: number;

    /** Sabitlenmiş mi (üste pin) */
    sabitlendi?: boolean;
}
